import { getVsicThunk } from '../../../../common/category/store/thunk'
import { getUnique } from '../../../../helpers/common'
import { default as ChartDistribution } from '../../../../portfolioInsights/segment/businessDistribution/ChartComponent'
import { default as TableDistribution } from '../../../../portfolioInsights/segment/businessDistribution/TableComponent'
import { resetBusinessDistribution } from '../../../../portfolioInsights/segment/businessDistribution/store/slice'
import { getBusinessSize } from '../../../../portfolioInsights/segment/businessDistribution/store/thunk'
import { resetIndustry } from '../../../../portfolioInsights/segment/portfolioIndustry/store/slice'
import { getIndustry } from '../../../../portfolioInsights/segment/portfolioIndustry/store/thunk'
import DynamicIndustry from '../../../../portfolioInsights/segment/portfolioIndustry/table/DynamicIndustry'
import TableComponent from '../../../../portfolioInsights/segment/portfolioProvince/TableComponent'
import { resetProvince } from '../../../../portfolioInsights/segment/portfolioProvince/store/slice'
import { getProvince } from '../../../../portfolioInsights/segment/portfolioProvince/store/thunk'
import { default as ChartYear } from '../../../../portfolioInsights/segment/yearDistribution/ChartComponent'
import { default as TableYear } from '../../../../portfolioInsights/segment/yearDistribution/TableComponent'
import { resetYearDistribution } from '../../../../portfolioInsights/segment/yearDistribution/store/slice'
import { getYearOperation } from '../../../../portfolioInsights/segment/yearDistribution/store/thunk'
import { MAIN_SCREEN, SCREEN, TYPE_ITEM_SETTING, VIEW_BY } from '../../constant'

const PANELS = {
  PORTFOLIO_ALLOCATION_BY_PROVINCE: 'portfolioAllocationByProvince',
  PORTFOLIO_ALLOCATION_BY_INDUSTRY: 'portfolioAllocationByIndustry',
  BUSINESS_SIZE_DISTRIBUTION: 'businessSizeDistribution',
  YEARS_OF_OPERATION_DISTRIBUTION: 'yearsOfOperationDistribution',
}

export const getPanelListSegment = () => {
  return [
    {
      label: 'dynamicReport.SEGMENT',
      children: [
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SEGMENT,
          panel: PANELS.PORTFOLIO_ALLOCATION_BY_PROVINCE,
          label: 'dynamicReport.PORTFOLIO_ALLOCATION_BY_PROVINCE',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SEGMENT,
          panel: PANELS.PORTFOLIO_ALLOCATION_BY_INDUSTRY,
          label: 'dynamicReport.PORTFOLIO_ALLOCATION_BY_INDUSTRY',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SEGMENT,
          panel: PANELS.BUSINESS_SIZE_DISTRIBUTION,
          label: 'dynamicReport.BUSINESS_SIZE_DISTRIBUTION',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.TABLE,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SEGMENT,
          panel: PANELS.YEARS_OF_OPERATION_DISTRIBUTION,
          label: 'dynamicReport.YEARS_OF_OPERATION_DISTRIBUTION',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.TABLE,
          },
        },
      ],
    },
  ]
}

export const getPanelPortfolioBySegment = (panel, { viewBy }) => {
  switch (panel) {
    case PANELS.PORTFOLIO_ALLOCATION_BY_PROVINCE:
      return {
        renderComponent: () => <TableComponent isDynamicReport={true} />,
        thunk: [({ portfolioParams }) => getProvince(portfolioParams)],
        isWaitForMount: true,
        isTable: true,
        return: (dispatch) => dispatch(resetProvince()),
      }
    case PANELS.PORTFOLIO_ALLOCATION_BY_INDUSTRY:
      return {
        renderComponent: () => <DynamicIndustry />,
        thunk: [
          ({ portfolioParams }) => getIndustry(portfolioParams),
          () => getVsicThunk(),
        ],
        isWaitForMount: true,
        isTable: true,
        return: (dispatch) => dispatch(resetIndustry()),
      }
    case PANELS.BUSINESS_SIZE_DISTRIBUTION:
      return {
        renderComponent: () =>
          viewBy === VIEW_BY.TABLE ? (
            <TableDistribution isDynamicReport={true} />
          ) : (
            <ChartDistribution />
          ),
        thunk: [({ portfolioParams }) => getBusinessSize(portfolioParams)],
        isWaitForMount: viewBy === VIEW_BY.TABLE,
        isTable: true,
        return: (dispatch) => dispatch(resetBusinessDistribution()),
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
        },
      }
    case PANELS.YEARS_OF_OPERATION_DISTRIBUTION:
      return {
        renderComponent: () =>
          viewBy === VIEW_BY.TABLE ? (
            <TableYear isDynamicReport={true} />
          ) : (
            <ChartYear />
          ),
        thunk: [({ portfolioParams }) => getYearOperation(portfolioParams)],
        isWaitForMount: viewBy === VIEW_BY.TABLE,
        isTable: true,
        return: (dispatch) => dispatch(resetYearDistribution()),
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
        },
      }
    default:
      break
  }
}

export const getDefaultSegment = () => {
  const [segment] = getPanelListSegment()

  return segment.children.map((panel) => {
    return {
      ...panel,
      id: getUnique(),
    }
  })
}
